// extracted by mini-css-extract-plugin
export default {"phone":"styles_phone__U8o3P","spin":"styles_spin__IXW9H"};